import decodeUriComponent from 'decode-uri-component';
import Ad from './Ad';
import Adnimation from './Adnimation';
import ReactModal  from 'react-modal';
import { useState, useEffect } from 'react';
import Btn from './Button';
import External from './Extrenal';
import AdsInternal from './AdsInternal';
import { useTranslation } from 'react-i18next';
import { Bell, Leaf, FlaskFlorence } from 'react-bootstrap-icons';
import {  Link } from "react-router-dom";
import SeasonClock from './SeasonClock';

const Notifications = (props) => {
    const [isOpen, setPopupIsOpen] = useState(false);
    const [isFaqOpen, setFaqIsOpen] = useState(false);
    const [isFullText, setFullText] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { t } = useTranslation();
    const toggleOpen = () => {
        
        setPopupIsOpen(!isOpen);
      }
    const toggleFaq = () => {
        
        setFaqIsOpen(!isFaqOpen);
      }
    const toggle_notification = () =>{
      setFullText(!isFullText);
    }

    const customStyles = {
      content: {
        width:(screenWidth > 800 ) ? '420px' :'100%',
        padding: '5px',
        top: '0',
        left: '0',
        direction: (props.lang == 1) ? 'rtl' : '',
        right: 'auto',
        bottom: '0',
        position: 'absolute',
        marginRight: '',
        transform: '',
      },
    };
    useEffect(() => {
                const handleResize = () => {
                    setScreenWidth(window.innerWidth);
                    //alert(window.innerWidth);
        
                };
                
                handleResize();
                window.addEventListener('resize', handleResize);
        
                // Clean up the event listener when the component unmounts
                return () => {
                    window.removeEventListener('resize', handleResize);
                };
                
                }, []); // Empty dependency array means this effect runs once on mount
    const visibleAlerts = props.notifications.alerts.filter(alert =>
      !alert.ttl ||
      (alert.ttl > 0 && (alert.ttl * 60) - alert.passedts > 0)
    );
    
    return (
        <div className="now_messages ">
        <h3 id="notification_title">{t("MESSAGES")}</h3>       
        <div id="alerts" className={"white_transp_box modern span7 offset3  " + (props.lang == 1? 'rtl textright' : 'textleft')} >
       {visibleAlerts.map((alert, i) => {

        const isVideo = alert.img_src?.includes("mp4");
        const isImg = alert.img_src && !isVideo;

        const title = decodeUriComponent(alert[`title${props.lang}`])
          .replace(/\+/g, " ");

        const textAlert = decodeUriComponent(alert[`desc${props.lang}`])
          .replace(/\+/g, " ")
          .replace(/(\r\n|\r|\n)/g, "<br/>");

        const shortTextAlert =
          textAlert.length > 120
            ? textAlert.substring(0, 120) + "..."
            : textAlert;

        const formattedDate = new Intl.DateTimeFormat("he-IS", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        }).format(alert.ts * 1000);
       return (
          <div className="notification" key={alert.id ?? i}>

            <h4>
              {alert.type === "long_term" ? (
                <Bell color="royalblue" />
              ) : alert.type === "short_term" ? (
                <Bell color="purple" />
              ) : (
                <Bell color="green" />
              )}
              {title}
            </h4>

            <div className="date_notification">
              {formattedDate}
            </div>

            {isImg && (
              <img src={alert.img_src} width="290" alt="" />
            )}

            {isVideo && (
              <video width="310" height="240" controls>
                <source src={alert.img_src} type="video/mp4" />
              </video>
            )}

            <Link onClick={toggle_notification}>
              <div
                className={isFullText
                  ? "text_notification"
                  : "text_notification_short"}
                dangerouslySetInnerHTML={{
                  __html: isFullText ? textAlert : shortTextAlert
                }}
              />
            </Link>

            <Btn
              btnOnClick={toggle_notification}
              img={isFullText ? "ChevronUp" : "ChevronDown"}
              cssClasses="d-flex align-items-end"
            />

            {/* Ads using visible index */}
            {i === 0 && <AdsInternal ads={props.ads} location="other" />}
            {i === 2 && <Adnimation width={320} height={50} format="a" />}
            {i === 4 && <Adnimation width={320} height={50} format="b" />}

          </div>
        )
            
        
        })}

        <SeasonClock minutes={props.season_index} lang={props.lang} />  
         
         <Btn btnOnClick={() => toggleOpen(true)} btnTitleText={t("MORE_NOTIFICATIONS")}  img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"}>
                
          </Btn>
          
          <Btn btnOnClick={() => toggleFaq(true)} btnTitleText={t("FAQ")}  img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"}>
                
          </Btn>  
      </div>
      <ReactModal
        
        isOpen={isOpen}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={() => toggleOpen(false)}

      >
         <Btn btnOnClick={() => toggleOpen(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                
        </Btn>
        <div className="sidepopup">
        <External src={"https://v2013.02ws.co.il/small/?section=alertarchive&lang=" + props.lang} width="380" height="95%" className={props.cssClasses}/>
        </div>
      </ReactModal>
      <ReactModal
              
            isOpen={isFaqOpen}
            contentLabel="Example Modal"
            style={customStyles}
            onRequestClose={() => toggleFaq(false)}
    
          >
              <Btn btnOnClick={() => toggleFaq(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                    
            </Btn>
            <div className="sidepopup">
            <External src={"https://v2013.02ws.co.il/small/?section=faq.php&lang=" + props.lang} width="380" height="95%" className={props.cssClasses}/>
            </div>
       </ReactModal>
    </div>
    );
}

export default Notifications; 